import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { NavHeader } from "@/components/nav/nav-header"
import { RouteLoadingMinimal } from "@/components/route-loading"
import { ensureSession } from "@/http/auth/session"

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async () => {
    const hasSession = await ensureSession()
    if (!hasSession) {
      throw redirect({ to: "/" })
    }
    return null
  },
  component: () => {
    return (
      <div className="h-dvh flex flex-col">
        <NavHeader />
        <div className="flex flex-1 flex-col gap-4 px-4 pt-16 pb-10">
          <Outlet />
        </div>
      </div>
    )
  },
  pendingComponent: RouteLoadingMinimal,
})
